var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"dark":_vm.dark,"fab":_vm.fab,"color":"info","to":_vm.$route.path + '/add'}},"v-btn",_vm._d({},[_vm.size,true])),[_c('v-icon',_vm._b({attrs:{"dark":_vm.dark}},"v-icon",_vm._d({},[_vm.size,true])),[_vm._v(" mdi-plus ")]),(!_vm.fab)?_c('span',[_vm._v(" Add")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }